import Vue from 'vue';
import VueResource from 'vue-resource';
import VueAnalytics from 'vue-analytics';
import _ from 'lodash';
import './core/filters';
import './services/forms/bootstrap';
import './core/i18n';
import { Alert } from './services/alert';

import Register from './components/Register.vue';
import VerifyEmail from './components/register/VerifyEmail.vue';
import RegisterFakeDealsBoard from './components/register/FakeDealsBoard.vue';
import IconChevron from './components/icon/Chevron.vue';
import '../sass/preflight.css';
import 'tailwindcss/tailwind.css';

Vue.use(VueResource);
Vue.use(VueAnalytics, { id: ['UA-65677980-5'] });

const ToggleButton = require('vue-js-toggle-button').default;

Vue.use(ToggleButton);

/**
 * Set CSRF token on ajax requests (jQuery and Vue).
 */
const csrf = document.querySelector('#csrf-token');

if (csrf) {
  Vue.http.headers.common['X-CSRF-TOKEN'] = csrf.getAttribute('content');
}

window.Alert = Alert;

Vue.component('IconChevron', IconChevron);

new Vue({
  el: '#salesflow',
  components: {
    Register,
    VerifyEmail,
    RegisterFakeDealsBoard,
  },
});
